'use client';

import { useCart } from '@/lib/cart';
import { ShoppingBag } from 'lucide-react';

export default function CartButton({ onClick }: { onClick?: () => void }) {
  const { count, openCart } = useCart();

  const handleClick = () => {
    if (onClick) onClick();
    openCart();
  };

  return (
    <button
      onClick={handleClick}
      className="relative w-11 h-11 rounded-full border border-[#C9A961] bg-[#2B1810]/40 backdrop-blur-sm text-[#C9A961] hover:bg-[#C9A961] hover:text-[#2B1810] transition-all duration-500 flex items-center justify-center group"
      aria-label={`Panier - ${count} article${count > 1 ? 's' : ''}`}
    >
      <ShoppingBag size={18} className="group-hover:scale-110 transition-transform" />
      {count > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 rounded-full bg-[#D4A017] text-[#2B1810] text-[10px] font-bold flex items-center justify-center border-2 border-[#2B1810] animate-pulse-gold">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
}
